import { Component, Input } from '@angular/core';
import { IPageHeader } from './pageHeader.model';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DOMAIN } from '../../../configurations/defaultConfigs';

@Component({
  selector: 'app-pageheader',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  providers: [TranslatePipe, TranslateService],
  templateUrl: './pageheader.component.html',
})
export class PageheaderComponent {
  @Input() pageOptions: IPageHeader = {
    mainPage: { title: '', path: '' },
    children: [],
  };
  domain = DOMAIN;
}
